module.exports = __webpack_public_path__ + "img/7.4.0-3-mobile.1464a936.png";